import {DI_TOKENS} from '@/di/di.tokens';
import {ResultGiftType} from '@/stores/GiftsStore/GiftsStore.constants';

import {injected} from 'brandi';

import {AbstractStorage} from '@specials/localstorage';

import {LSKeys} from '@/constants';
import {WinnersStore} from '@/stores/WinnersStore/WinnersStore';

export class WinnersService {
  constructor(private readonly localStorage: AbstractStorage, private readonly winnersStore: WinnersStore) {}

  public setWasSeenWinnersModalTrue = (): void => {
    this.winnersStore.setWasSeenWinnersModal(true);
    this.localStorage.setItem(LSKeys.WasSeenWinnersModal, 'true');
  };

  public setActiveTabStocks = (): void => {
    this.winnersStore.setActiveTab(ResultGiftType.Stocks);
  };

  public setActiveTabMoney = (): void => {
    this.winnersStore.setActiveTab(ResultGiftType.Money);
  };

  public setActiveTabTShop = (): void => {
    this.winnersStore.setActiveTab(ResultGiftType.TShop);
  };
}

injected(WinnersService, DI_TOKENS.localStorageService, DI_TOKENS.winnersStore);
